import { ProductSpecificationValuesProps } from './@types/ProductSpecificationValuesProps';
import ProductSpecificationValuesProvider from './hooks/useProductSpecificationValues';

const ProductSpecificationValues = (props: ProductSpecificationValuesProps) => (
	<ProductSpecificationValuesProvider {...props}>{props.children}</ProductSpecificationValuesProvider>
);

export default ProductSpecificationValues;
